module.exports = __webpack_public_path__ + "assets/img/71.0e1498dc.png";